import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    CLEAR_USER(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  getters: {
    isSuperAdmin: state => state.userInfo.roleType === 'SUPER_ADMIN',
    isSubAdmin: state => state.userInfo.roleType === 'SUB_ADMIN',
    isUser: state => state.userInfo.roleType === 'USER',
    canImport: state => state.userInfo.canImport === 1,
    roleType: state => state.userInfo.roleType
  }
})
